import { Box } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import React from "react";

interface Props {
  children?: React.ReactElement[] | React.ReactElement;
}

export default function DetailsLable({ children }: Props) {
  return (
    <Box
      sx={{
        flex: 1,
        // border: "1px solid gray",
        borderColor: blueGrey[100],
        borderWidth: "1px",
        borderStyle: "solid",
        boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        // alignItems: "center",
        justifyContent: "space-between",
        borderRadius: "8px",
        backgroundColor: "bgColor.white",
        padding: "6px",
      }}
    >
      {children}
    </Box>
  );
}
